import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import ScrollToTop from "./components/ScrollToTop";
import SEOHead from "./components/SEOHead";
import TrialBanner from "./components/TrialBanner";
import GoogleAnalytics from "./components/analytics/GoogleAnalytics";
import HubSpotTracking from "./components/analytics/HubSpotTracking";
import HomePage from "./pages/HomePage";
import ProductPage from "./pages/ProductPage";
import IndustriesPage from "./pages/IndustriesPage";
import InsightsPage from "./pages/InsightsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import PricingPage from "./pages/PricingPage";
import ROICalculatorPage from "./pages/ROICalculatorPage";
import SimulatorPage from "./pages/SimulatorPage";
import PartnersPage from "./pages/PartnersPage";
import PEDPage from "./pages/PEDPage"; // Landing page
import FeaturesPage from "./pages/FeaturesPage";
import LoginPage from "./pages/auth/LoginPage";
import SignupPage from "./pages/auth/SignupPage";
import DashboardPage from "./pages/DashboardPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import AdminSubscribersPage from "./pages/admin/AdminSubscribersPage";
import AdminAnalyticsPage from "./pages/admin/AdminAnalyticsPage";
import InsightArticle1 from "./pages/insights/InsightArticle1";
import InsightArticle2 from "./pages/insights/InsightArticle2";
import InsightArticle3 from "./pages/insights/InsightArticle3";
import InsightArticle4 from "./pages/insights/InsightArticle4";
import InsightArticle5 from "./pages/insights/InsightArticle5";
import InsightArticle6 from "./pages/insights/InsightArticle6";
import RetailCaseStudy from "./pages/case-studies/RetailCaseStudy";
import HealthcareCaseStudy from "./pages/case-studies/HealthcareCaseStudy";
import TechSaaSCaseStudy from "./pages/case-studies/TechSaaSCaseStudy";
import ManufacturingCaseStudy from "./pages/case-studies/ManufacturingCaseStudy";
import ProfessionalServicesCaseStudy from "./pages/case-studies/ProfessionalServicesCaseStudy";
import CommoditiesCaseStudy from "./pages/case-studies/CommoditiesCaseStudy";
import WholesaleCaseStudy from "./pages/case-studies/WholesaleCaseStudy";
import FoodBeverageCaseStudy from "./pages/case-studies/FoodBeverageCaseStudy";
import AutoPartsCaseStudy from "./pages/case-studies/AutoPartsCaseStudy";
import FitnessCaseStudy from "./pages/case-studies/FitnessCaseStudy";
import ConstructionCaseStudy from "./pages/case-studies/ConstructionCaseStudy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import CookiePolicy from "./pages/CookiePolicy";
import PricingHealthCheck from "./pages/PricingHealthCheck";
import StrategyPage from "./pages/StrategyPage";
import TEDTalkPage from "./pages/TEDTalkPage";
import ShopifyTEDTalkPage from "./pages/ShopifyTEDTalkPage";
import ShareLinksPage from "./pages/ShareLinksPage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CurrencyProvider>
          {/* Analytics & Tracking */}
          <GoogleAnalytics />
          <HubSpotTracking />
          
          {/* SEO - Dynamic meta tags */}
          <SEOHead />
          
          <ScrollToTop />
          <TrialBanner />
          <div className="App">
          <Routes>
            <Route path="/" element={<PEDPage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/coming-soon" element={<ComingSoonPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/admin/subscribers" element={<AdminSubscribersPage />} />
            <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/insights/5-pricing-mistakes-cost-smbs-thousands" element={<InsightArticle1 />} />
            <Route path="/insights/ai-democratizing-enterprise-pricing" element={<InsightArticle2 />} />
            <Route path="/insights/retail-smb-increased-margins-28-percent" element={<InsightArticle3 />} />
            <Route path="/insights/2025-pricing-trends-smb-should-know" element={<InsightArticle4 />} />
            <Route path="/insights/building-data-driven-pricing-culture" element={<InsightArticle5 />} />
            <Route path="/insights/real-time-competitive-intelligence" element={<InsightArticle6 />} />
            <Route path="/case-studies/retail" element={<RetailCaseStudy />} />
            <Route path="/case-studies/healthcare" element={<HealthcareCaseStudy />} />
            <Route path="/case-studies/tech-saas" element={<TechSaaSCaseStudy />} />
            <Route path="/case-studies/manufacturing" element={<ManufacturingCaseStudy />} />
            <Route path="/case-studies/professional-services" element={<ProfessionalServicesCaseStudy />} />
            <Route path="/case-studies/commodities" element={<CommoditiesCaseStudy />} />
            <Route path="/case-studies/wholesale" element={<WholesaleCaseStudy />} />
            <Route path="/case-studies/food-beverage" element={<FoodBeverageCaseStudy />} />
            <Route path="/case-studies/auto-parts" element={<AutoPartsCaseStudy />} />
            <Route path="/case-studies/fitness" element={<FitnessCaseStudy />} />
            <Route path="/case-studies/construction" element={<ConstructionCaseStudy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/roi-calculator" element={<ROICalculatorPage />} />
            <Route path="/simulator" element={<SimulatorPage />} />
            <Route path="/pricing-check" element={<PricingHealthCheck />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/strategy" element={<StrategyPage />} />
            <Route path="/ted-talk" element={<TEDTalkPage />} />
            <Route path="/shopify-talk" element={<ShopifyTEDTalkPage />} />
            <Route path="/share-links" element={<ShareLinksPage />} />
          </Routes>
        </div>
        </CurrencyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
